export default __webpack_public_path__ + "static/media/s0_female.3e99c50b.wav";